export const createImageUrl = (
  imagesPath: string | null,
  w: number,
  h: number
) => {
  if (!imagesPath || imagesPath.length === 0) return null;
  return `${imagesPath}${w}x${h}.png`;
};
